import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { getChinaLocalization } from 'shared/account/reducer';
import { T } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import { getPaddlePlanIdForCurrentPlan } from '../reducer';
import { PLAN_EXPIRATION } from '../constants';
import PlanManagementButton from '../plan/PlanManagementButton';
var RubriqNotificationBox = function RubriqNotificationBox() {
  var curiePlan = useSelector(function (_ref) {
    var curie = _ref.curie;
    return curie.plan;
  });
  var planStatus = curiePlan.status,
    planType = curiePlan.planType;
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var upgradeLink = useCartInsteadOfPaddle ? '/rubriq/plan/subscribe' : '/rubriq/plan/subscribe/premium';
  var hasCrossedExpirationThreshold = function hasCrossedExpirationThreshold() {
    return curiePlan.endsAt && moment(curiePlan.endsAt) <= moment().add(PLAN_EXPIRATION.REMAINING_THRESHOLD, 'd');
  };
  var isActiveCartPurchaseSub = curiePlan.receiptCode && planStatus === 'active';
  var notification = function () {
    if (planType === 'premium') {
      if (planStatus === 'expired') {
        return /*#__PURE__*/React.createElement(T.md, {
          inline: true,
          useLink: true,
          source: "curie.premium-expired-notification",
          params: {
            link: '/rubriq/plan/subscribe'
          }
        });
      }
      if (isActiveCartPurchaseSub && hasCrossedExpirationThreshold()) {
        return /*#__PURE__*/React.createElement(T.md, {
          inline: true,
          useLink: true,
          source: "curie.premium-to-be-expired-notification",
          params: {
            link: '/rubriq/plan/subscribe'
          }
        });
      }
      if (!useCartInsteadOfPaddle && planStatus === 'error') {
        return /*#__PURE__*/React.createElement(T.md, {
          inline: true,
          source: "curie.payment-failed-within-grace-period",
          linkRenderer: function linkRenderer(_ref2) {
            var _curiePlan$paddleSubs;
            var children = _ref2.children;
            return /*#__PURE__*/React.createElement(PlanManagementButton, {
              classicUrl: (_curiePlan$paddleSubs = curiePlan.paddleSubscription) === null || _curiePlan$paddleSubs === void 0 ? void 0 : _curiePlan$paddleSubs.updateUrl,
              targetAction: "update",
              paddlePlanId: useSelector(getPaddlePlanIdForCurrentPlan),
              asButton: false
            }, children);
          }
        });
      }
    }
    if (planType === 'free_trial' && planStatus === 'expired') {
      return /*#__PURE__*/React.createElement(T.md, {
        inline: true,
        useLink: true,
        source: "curie.free-trial-expired",
        params: {
          upgradeLink: upgradeLink
        }
      });
    }
    if (curiePlan.status === 'error') {
      return /*#__PURE__*/React.createElement(T.md, {
        inline: true,
        useLink: true,
        source: "curie.failed-payment-message",
        params: {
          upgradeLink: upgradeLink
        }
      });
    }
    return null;
  }();
  return notification ? /*#__PURE__*/React.createElement("div", {
    className: "row mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-0"
  }, notification)))) : null;
};
export default RubriqNotificationBox;